// 宏
// 重置状态
export const RESETSTATE = 'RESETSTATE';
// 设置选中项目Id
export const SET_CHECKPROJECTID = 'SET_CHECKPROJECTID';
// 设置选中类型
export const SET_CHECKTYPE = 'SET_CHECKTYPE';
// 设置选中项
export const SET_CHECKITEM = 'SET_CHECKITEM';
// 设置选中组件
export const SET_CHECKEDPARAM = 'SET_CHECKEDPARAM';
// 设置帮助模块是否显示
export const SET_ISHELPSHOW = 'SET_ISHELPSHOW';
// 设置是否从详情返回
export const SET_ISDETAILBACK = 'SET_ISDETAILBACK';



// WEBPACK FOOTER //
// ./src/store/mutations-types.js